module.exports = __webpack_public_path__ + "img/codetest.0a93ea37.png";